export const isEmailVerified = () => {
  if (localStorage.getItem("emailVerified") !== true) {
    return true;
  } else return false;
};


export const isOnboarding = () => {
  if (
    localStorage.getItem("isDetails") == "true" &&
    localStorage.getItem("isContactDetails") == "true"
  ) {
    return true;
  } else return false;
};
